//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Treg Anderson
 * Original Team: Mavericks
 */
import { VForm, VBtn } from 'vuetify/lib';
import NsCreditCardDate from './NsCreditCardDate.vue';

export default {
  name: 'NsExpireDateForm',
  components: {
    NsCreditCardDate,
    VForm,
    VBtn,
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },

    translations: {
      type: Object,
      default() {
        return {
          continue: 'Continue',
          creditCardDate: {
            invalidDate: 'Invalid Date Entered',
            label: 'Expiration Date',
            monthPlaceholder: '',
            yearPlaceholder: '',
            fieldRequired: 'Required',
          },
        };
      },
    },
  },
  data() {
    return {
      cardDate: {
        expMonth: this.value.expMonth,
        expYear: this.value.expYear,
      },
      dateValid: false,
      disableDate: false,
      loading: false,
      t: this.translations,
    };
  },
  watch: {
    translations() {
      this.t = this.translations;
    },

    value() {},
  },
  mounted() {},
  methods: {
    doContinue() {
      if (this.dateValid) {
        this.loading = true;
        this.$emit('input', { ...this.cardDate });
      }
    },
    setValid(valid) {
      this.dateValid = valid;
    },
    updateExpireDate(value) {
      this.$set(this.cardDate, 'expMonth', value.expMonth);
      this.$set(this.cardDate, 'expYear', value.expYear);
    },
  },
};
